import styled from "styled-components/macro";

import { Column } from "components/Layout";

export const ActionColumn = styled(Column)`
  min-width: 15%;
`;
